import React, { useEffect, useState } from "react"
import Cleave from "cleave.js/react"
import "cleave.js/dist/addons/cleave-phone.br"
import * as _ from "lodash"
import PropTypes from "prop-types"
import API from "../Utils/api"
import { Link } from 'react-router-dom';


import { generatePassword, validateCPF, validateEmail } from "../Utils/validation";

const FormCliente = ({ perfil, tutorId, id = null, redirect }) => {
    const initialState = {
        nome: '',
        telefone: '',
        comissao: '',
        cpf: '',
        endereco: '',
        bairro: '',
        cidade: '',
        estado: '',
        status: 'true',
        clicked: false
    }
    const [resetSenha, setResetSenha] = useState(false)
    const [form, setForm] = useState(initialState);
    const [errors, setErrors] = useState({ nome: '',  cpf: '' });
    const [cleaves, setCleaves] = useState({
        cpfCleave: null,
        telefoneCleave: null
    })

    useEffect(() => {
        buscarCambistaPeloId(id)
    }, [id])

    const buscarCambistaPeloId = async id => {
        if (id != null) {
            const { data } = await API.get(`/api/usuarios/${id}`)
            if (data) {
                const status = data.status ? 'true' : 'false'

                setForm(prevState => {
                    return {
                        ...prevState,
                        ...data,
                        status
                    }
                })
            }
        }
    }

    const validateFields = ({ cpf, nome }) => {
        const errors = {};

        if (!nome) errors['nome'] = 'Nome é um campo obrigatório';
        if (nome && nome.length <= 3) errors['nome'] = 'Nome muito curto';
        // if (!email) errors['email'] = 'Email é um campo obrigatório';
        // if (!validateEmail(email)) errors['email'] = 'Email inválido';

        setErrors({ ...errors })
    }

    const telefoneInit = (cleave) => {
        setCleaves(prevState => {
            return {
                ...prevState,
                telefoneCleave: cleave,
            }
        })
    }

    const cpfInit = (cleave) => {
        setCleaves(prevState => {
            return {
                ...prevState,
                cpfCleave: cleave,
            }
        })
    }

    const handleResetForm = event => {
        setForm(initialState)
        setErrors({})
        setResetSenha(false)
        for (let key in cleaves) {
            cleaves[key] = null;
            // cleaves[key].setRawValue('')
        }
    }

    const handleInputChange = event => {
        const { name, value } = event.target
        setForm(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        })
    }

    const handleResetSenha = event => {
        const { checked } = event.target
        setResetSenha(checked)
    }

    const handleRequiredCleaveLength = event => {
        const minLength = event.target.dataset.length
        const { name, rawValue } = event.target

        if (rawValue && rawValue.length < minLength) {
            setForm(prevState => {
                return {
                    ...prevState,
                    [name]: ''
                }
            })
            cleaves[`${name}Cleave`].setRawValue('')
        }
    }

    const validateForm = async () => {
        validateFields({ ...form })
    }

    const handleSubmit = async event => {
        event.preventDefault()
        let senha = ''
        const status = form.status === 'true'
        // form.clicked = true;
        if (_.isEmpty(errors)) {
            if (!id) {
                senha = generatePassword()
                const response = await API.post('/api/usuarios', {
                    ...form, tutorId, perfil, senha, status
                })

                const responseError = response.data.error;
                if (responseError) {
                    alert(responseError)
                    return
                }

            } else {
                // atualizar o registro
                const dados = { ...form, tutorId, perfil, status, usuarioId: id }
                var response;
                if (resetSenha) {
                    senha = generatePassword();
                    dados.senha = senha
                    response = await API.post('/api/usuarios/atualizar-usuario', dados)
                }
                else {
                    response = await API.post('/api/usuarios/atualizar-usuario-manter-senha', { ...dados })
                }

                if (response.data === 1) {
                    let message = 'Registro atualizado com sucesso.'
                    if (resetSenha) message = message.concat(`\nAnote sua nova senha: ${senha}`)
                    alert(message)
                    if (redirect) window.location.href = `/${redirect}`
                }
            }

            handleResetForm()

            if (!id) {
                alert(`Cadastro realizado com sucesso.Obs.: Anote a senha: ${senha}, telefone: ${form.telefone}`);
                if (redirect) window.location.href = `/${redirect}`
            }
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="form-group col-lg-9">
                    <label htmlFor="nome">NOME</label>
                    <input type="text" name="nome"
                        onChange={handleInputChange}
                        value={form.nome || ''}
                        className={`form-control ${errors.nome && 'is-invalid'}`} placeholder="Nome" />
                    <div className="invalid-feedback">
                        {errors.nome}
                    </div>
                </div>
                <div className="form-group col-lg-3">
                    <label htmlFor="cpf">CPF</label>
                    <Cleave placeholder="999.999.999-99"
                        value={form.cpf || ''}
                        name="cpf" data-length="11"
                        onInit={cpfInit}
                        className={`form-control ${errors.cpf && 'is-invalid'}`}
                        options={{
                            numericOnly: true,
                            delimiters: ['.', '.', '-'],
                            blocks: [3, 3, 3, 2]
                        }}
                        onChange={handleInputChange}
                        onBlur={handleRequiredCleaveLength}
                    />
                    <div className="invalid-feedback">
                        {errors.cpf}
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-3">
                    <label htmlFor="telefone">TELEFONE</label>
                    <Cleave name="telefone"
                        placeholder="99 99999 9999"
                        data-length="10"
                        value={form.telefone || ''}
                        onInit={telefoneInit}
                        className="form-control"
                        options={{
                            phone: true,
                            phoneRegionCode: 'BR'
                        }}
                        onChange={handleInputChange}
                        onBlur={handleRequiredCleaveLength}
                    />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-7">
                    <label htmlFor="endereco">Endereço</label>
                    <input type="text" name="endereco" className="form-control" placeholder="Endereço"
                        value={form.endereco || ''}
                        onChange={handleInputChange} />
                </div>
                <div className="form-group col-lg-5">
                    <label htmlFor="bairro">Bairro</label>
                    <input type="text" name="bairro" className="form-control" placeholder="Bairro"
                        value={form.bairro || ''}
                        onChange={handleInputChange} />
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-4">
                    <label htmlFor="cidade">Cidade</label>
                    <input type="text" name="cidade" className="form-control" placeholder="Cidade"
                        value={form.cidade || ''}
                        onChange={handleInputChange} />
                </div>
                <div className="form-group col-lg-4">
                    <label htmlFor="estado">Estado</label>
                    <input type="text" name="estado" className="form-control" placeholder="Estado"
                        value={form.estado || ''}
                        onChange={handleInputChange} />
                </div>
                <div className="form-group col-lg-4">
                    <label htmlFor="status">Status</label>
                    <select id="status" name="status"
                        onChange={handleInputChange}
                        value={form.status || 'true'}
                        className="form-control custom-select"
                        style={{ height: 'calc(2.25rem + 4px)' }}>
                        <option value="">Selecione...</option>
                        <option value="true">Ativo</option>
                        <option value="false">Bloqueado</option>
                    </select>
                </div>
            </div>
            {id && (
                <div className="row">
                    <div className="col-lg-12">
                        <input type="checkbox" id="exampleCheck1" checked={resetSenha} onChange={handleResetSenha} />
                        <label className="form-check-label" htmlFor="exampleCheck1">Gerar nova senha ao salvar</label>
                    </div>
                </div>
            )}
            <div className="float-lg-right">
                { }
                <Link to="master-gerencia-clientes" className="btn btn-fill btn-secondary">Cancelar
                </Link>
                <button disabled={form.clicked} type="submit" onClick={validateForm}
                    className="btn btn-fill btn-success ml-lg-1 ml-md-1">Salvar
                </button>
            </div>
            <div className="clearfix"></div>
        </form>
    )
};

FormCliente.propTypes = {
    perfil: PropTypes.oneOf(['GERENTE', 'CAMBISTA', 'CLIENTE']).isRequired,
    tutorId: PropTypes.string,
    id: PropTypes.string
}

export default FormCliente